<script setup lang="ts">
import { fetchGlobalData, queryKey } from '~/queries'

await useAsyncData(queryKey('global-data'), fetchGlobalData)
const site = useSiteStore()

</script>

<template>
  <AppContainer class="my-10 md:my-20">
    <IllustrationBalloon class="mx-auto mb-10 h-auto w-44 text-red"></IllustrationBalloon>

    <div class="text-410">{{ $t('string.Expired') }}.</div>

    <div class="row justify-center text-center expiration-text">
      <div class="col-xl-6">
        <p class="h4 mb-3 md:mb-4 expiration-text-color">
          {{ $t('string.Expired-Description') }} <a
          v-if="site.data?.emailAddress"
          :href="`mailto:${site.data.emailAddress}`"
          class="max-w-full truncate expiration-text-color"
          :title="site.data.emailAddress"
        >
          {{ site.data.emailAddress }}
        </a>
        </p>
      </div>
    </div>
    <div class="row justify-center">
      <div class="col-sm-3 mb-3 sm:mb-0">
        <AppButton full-width to="/" external>{{ $t('string.Back-To-Home') }}</AppButton>
      </div>
    </div>
  </AppContainer>
</template>

<style lang="scss">
@import '@boats/ui/styles/config';

.balloon-illustration {
  width: 7.5rem;
  margin: 0 auto 0.75rem;

  @include media-breakpoint-up(md) {
    width: 11rem;
    margin-bottom: 0;
  }
}
.expiration-text {
  margin-bottom: 3rem;
}

.expiration-text-color {
  color: #5a5a5a;
}

.text-410 {
  margin-bottom: 3rem;
  font-family: $font-barlow-condensed;
  font-size: 5rem;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  color: $black;
}
</style>
